module.exports = __webpack_public_path__ + "static/img/m601.afa1850d.gif";